import { useEffect } from 'preact/hooks';

export function useUnmountEffect(callback: () => void) {
  return useEffect(() => () => callback(), []);
}
